<template>
  <div>
    <h2 v-t="'p.teamMembersPage.title'"/>

    <bar>
      <template slot="left">
        <search-input
          v-model="fetchParams.term"
          :is-loading="searchInProgress"
          @input="searchMemberships"
        />
      </template>
      <template slot="right">
        <dropdown-input
          :options="roleFilterDropdownOptions"
          trigger-icon="filter"
          @select="handleRoleFilterDropdownSelect"
        />
      </template>
    </bar>

    <pagination
      v-if="meta"
      :total-items="meta.totalCount"
      :items-per-page="meta.perPage"
      :page="meta.currentPage - 1"
      :loading="isLoading"
      @page-change="handlePageChange"
    />

    <team-member
      v-for="membership in memberships"
      :key="membership.id"
      :membership="membership"
      @roleChange="fetch"
    />

    <pagination
      v-if="meta"
      :total-items="meta.totalCount"
      :items-per-page="meta.perPage"
      :page="meta.currentPage - 1"
      :loading="isLoading"
      @page-change="handlePageChange"
    />

  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import Bar from '@/components/ui/Bar'
import TeamMember from '@/components/teams/TeamMember'
import Pagination from '@/components/ui/pagination/pagination-base'
import FormMixin from '@/mixins/forms/Form'

export default {
  name: 'TeamMembersPage',

  mixins: [FormMixin],

  components: {
    Bar,
    TeamMember,
    Pagination
  },

  data () {
    return {
      currentFilter: 'all',
      searchInProgress: false,
      fetchParams: {
        term: '',
        role: 'all',
        page: 1
      }
    }
  },

  computed: {
    ...mapState({
      meta: state => state.memberships.meta,
      memberships: state => state.memberships.memberships,
      isLoading: state => state.memberships.request.isLoading
    }),

    roleFilterDropdownOptions () {
      const entries = []
      const roles = ['all', 'owner', 'admin', 'editor', 'reader']
      roles.forEach(role => {
        entries.push({
          active: this.fetchParams.role == role,
          label: this.$t(`c.clientMember.label.${role}`),
          value: role
        })
      })

      return entries
    }
  },
  methods: {
    ...mapActions({
      fetchMemberships: 'fetchMemberships',
      loadingDone: 'app/loadingDone'
    }),

    fetch () {
      const teamId = this.$route.params.teamId

      return this.fetchMemberships({
        team_id: teamId,
        term: this.fetchParams.term,
        page: this.fetchParams.page,
        role: this.fetchParams.role
      })
    },

    handleRoleFilterDropdownSelect ({ value }) {
      this.fetchParams.page = 1
      this.fetchParams.role = value
      this.fetch()
    },

    searchMemberships () {
      this.searchInProgress = true
      this.fetch().then(() => this.searchInProgress = false)
    },

    handlePageChange (page) {
      this.fetchParams.page = page
      this.fetch()
    }
  },
  created () {
    this.fetch()
      .then(() => {
        this.loadingDone()
      })
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/teams/TeamMembersPage.vue